export const booleanString = (val?: string) => {
	if (!val) return false;
	return val === 'true';
};
